import React from "react";
import "./AdminSidebar.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import StorageIcon from "@mui/icons-material/Storage";
import FeedbackIcon from "@mui/icons-material/Feedback";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useNavigate } from "react-router-dom";
import { getMsalInstance } from "../../../msalConfig";
import { tokenRefreshService } from "../../../services/tokenRefreshService";
import { clearUserInfo } from "../../../utils/userUtils";
import { isAccessManagerEnabled } from "../../AccessManager/featureFlags";

const AdminSidebar = ({ activeMenu = "dashboard", onMenuChange }) => {
    const navigate = useNavigate();
  const items = [
    { id: "dashboard", label: "Dashboard", icon: DashboardIcon },
    { id: "sessions", label: "Sessions", icon: StorageIcon },
    { id: "feedbacks", label: "Feedbacks", icon: FeedbackIcon },
    { id: "search", label: "Search", icon: SearchIcon },
    { id: "semantic-settings", label: "Semantic Settings", icon: SettingsIcon },
    ...(isAccessManagerEnabled()
      ? [{ id: "access-manager", label: "Access Manager", icon: ManageAccountsIcon }]
      : []),
  ];

 const handleLogout = async () => {
     try {
       const msalInstance = getMsalInstance();
       
       tokenRefreshService.stopAutoRefresh();
       
       clearUserInfo();
       
       localStorage.removeItem("appToken");
       localStorage.removeItem("databricksToken");
       localStorage.removeItem("tokenExpiry");
       
       await msalInstance.logoutRedirect({
         postLogoutRedirectUri: "/",
       });
     } catch (error) {
       clearUserInfo();
       localStorage.clear();
       navigate("/");
     }
   };

  return (
    <nav className="admin-sidebar">
      <div className="admin-sidebar-section">
        <div className="admin-sidebar-section-title">Analytics</div>
        <ul className="admin-sidebar-list">
          {items.map((item) => {
            const IconComponent = item.icon;
            return (
              <li
                key={item.id}
                className={`admin-sidebar-item ${activeMenu === item.id ? "active" : ""}`}
                onClick={() => onMenuChange && onMenuChange(item.id)}
              >
                <IconComponent className="admin-sidebar-icon" />
                <span className="admin-sidebar-label">{item.label}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="admin-sidebar-footer">
        <button className="sidebar-logout-btn" onClick={handleLogout}>
          <LogoutIcon className="sidebar-logout-icon" />
          <span>Logout</span>
        </button>
        <div className="sidebar-footer-info">
          <div className="sidebar-version">v1.0.0</div>
          <div className="sidebar-copyright">© 2026 Emcure</div>
        </div>
      </div>
    </nav>
  );
};

export default AdminSidebar;


